export default {
 TOOLTIP:'A <b>shareholder register</b> (or register of members) is a record of all the active and former owners of a company’s shares. '
}